var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoticeChatwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.74 3.186a4.05 4.05 0 00-6.91 2.704v3.841a.362.362 0 00.362.362h3.506c1.232 0 2.207-.345 3.041-1.175a4.055 4.055 0 000-5.732z",
    fill: "#13202F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.186 6.272a4.049 4.049 0 002.704 6.91h3.841a.362.362 0 00.362-.366V9.313c0-1.232-.345-2.206-1.175-3.041a4.055 4.055 0 00-5.732 0zM6.273 20.813a4.049 4.049 0 006.909-2.704v-3.84a.361.361 0 00-.365-.363H9.314c-1.232 0-2.206.346-3.041 1.176a4.055 4.055 0 000 5.731zM20.812 17.728a4.046 4.046 0 00-2.704-6.908h-3.842a.36.36 0 00-.361.361v3.506c0 1.232.344 2.207 1.175 3.041a4.055 4.055 0 005.732 0z",
    fill: "#F03748"
  })));
}

export default SvgNoticeChatwork;